import { ImageGallery } from "@/@types/ui/ImageGallery";

export function transformProductImageGallery(data: any[]): ImageGallery[] {
  if (!Array.isArray(data) || data.length === 0) return [];

  return data.map((imageMedia) => {
    const rawSrc = imageMedia.local || imageMedia.media_url || imageMedia.media

    const src = typeof rawSrc === 'string' 
      ? rawSrc.replace(/^http:\/\//i, 'https://')
      : rawSrc
    
    const isScene7 = typeof src === 'string' && src.includes('scene7.com')

    return {
      src,
      unoptimized: isScene7
    }
  });
}